import Grid from '@mui/material/Grid';
import React from "react";


export default function CenteredBox(props) {
    return (
        <Grid
            container
            spacing={0}
            direction="column"
            style={{minHeight: props.height || '80vh'}}
            sx={{
                alignItems: "center",
                justifyContent: "center"
            }}>
            <Grid size='auto'>
                {props.children}
            </Grid>
        </Grid>
    );
}